import { render, staticRenderFns } from "./CompanySettingsPage.vue?vue&type=template&id=3055615f&scoped=true"
import script from "./CompanySettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanySettingsPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanySettingsPage.vue?vue&type=style&index=0&id=3055615f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055615f",
  null
  
)

export default component.exports